import {
	getImageBase64,
	getBackground
	, getThemePic
} from "@/views/home/slidePPT/use/methods"
import {
	pathToBase64,
} from '@/utils'

export default async function (data) {
	const node = data.node;
	const title = node.title;
	const serial = data.num;
	const color = data.color;
	const id = Math.random().toString(36).slice(-8);
	const background = await getBackground(data?.customTheme, 'theme')

	return {
		"id": id,
		"elements": [
			{
				"type": "text",
				"id": "9tTSIpIYAN",
				"width": 191.99640916268274,
				"height": 92,
				"left": 414.29968549419925,
				"top": 139.7141787634509,
				"rotate": 0,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333",
				"content": `<p style=\"text-align: center;\"><strong><span style=\"font-size: 60px;\"><span style=\"font-family: Aa之云体;\"><span style=\"color: #F9C5B8;\"><sub>${serial}</sub></span></span></span></strong></p>`,
				"lineHeight": 1,
				"outline": {
					"color": "#000",
					"width": 0,
					"style": "solid"
				},
				"fill": "",
				"vertical": false
			},
			{
				"type": "text",
				"id": "U2MZu9FYpW",
				"width": 316.76640586603617,
				"height": 92,
				"left": 343.3094034904924,
				"top": 279.43474863245643,
				"rotate": 0,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333",
				"content": `<p style=\"text-align: center;\"><span style=\"font-size: 60px;\"><span style=\"font-family: Aa之云体;\"><span style=\"color: #373536;\"><sub>${title}</sub></span></span></span></p>`,
				"lineHeight": 1,
				"outline": {
					"color": "#000",
					"width": 0,
					"style": "solid"
				},
				"fill": "",
				"vertical": false
			},
			{
				"type": "shape",
				"id": "wbW3dc4sRS",
				"width": 59.075384214639236,
				"height": 20.545350351654076,
				"left": 284.23401927585314,
				"top": 325.43474863245643,
				"viewBox": [
					59.06,
					20.54
				],
				"path": " M0,0 L59.05511811023622,0 L59.05511811023622,20.54445538057743 L0,20.54445538057743z",
				"fill": "#f9c5b8",
				"fixedRatio": false,
				"rotate": 0,
				"outline": {
					"color": "#000",
					"width": 0,
					"style": "solid"
				},
				"text": {
					"content": "<p style=\"text-align: left;\"><span style=\"font-size: 18.37px;font-family: Arial;\">&nbsp;</span></p>",
					"defaultFontName": "Microsoft Yahei",
					"defaultColor": "#333",
					"align": "top"
				},
				"flipH": false,
				"flipV": false,
				"special": true
			},
			{
				"type": "shape",
				"id": "F5owPZmeys",
				"width": 59.075384214639236,
				"height": 20.545350351654076,
				"left": 667.6638707996874,
				"top": 325.43474863245643,
				"viewBox": [
					59.06,
					20.54
				],
				"path": " M0,0 L59.05511811023622,0 L59.05511811023622,20.54445538057743 L0,20.54445538057743z",
				"fill": "#c3e2d2",
				"fixedRatio": false,
				"rotate": 0,
				"outline": {
					"color": "#000",
					"width": 0,
					"style": "solid"
				},
				"text": {
					"content": "<p style=\"text-align: left;\"><span style=\"font-size: 18.37px;font-family: Arial;\">&nbsp;</span></p>",
					"defaultFontName": "Microsoft Yahei",
					"defaultColor": "#333",
					"align": "top"
				},
				"flipH": false,
				"flipV": false,
				"special": true
			}
		],
		background
	}
}